import React, { useState, useEffect, useRef } from "react";
import { Table, Spinner } from "react-bootstrap";
import { useAlert } from "react-alert";
import { baseUrl } from "../../../../services/config";
import { Paper } from "@material-ui/core";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { PremissionChecker } from "../../../../services/PremissionChecker";
import { useSelector } from "react-redux";
import Pagination from "@material-ui/lab/Pagination";
import usePagination from "../../../../components/usePagination/usePagination";
import { upperCase } from "lodash";
import { DownloadTableExcel } from "react-export-table-to-excel";
import ReactToPrint from "react-to-print";
import "./../../MonthlyPaySheet/monthypay.css";
const DailyTestReport = () => {
  const user = useSelector((state) => state.user.user);
  const authtoken = localStorage.getItem("userToken");

  const [allSessions, setAllSessions] = useState([]);
  const [allSubjects, setAllSubjects] = useState([]);
  const [campuses, setallcampuses] = useState(user.campuses || []);
  const [campusCourseData, setCampusCourseData] = useState([]);
  const [courseClassData, setCourseClassData] = useState([]);
  const [classSectionData, setClassSectionData] = useState([]);

  const [currentSession, setCurrentSession] = useState("");
  const [campusId, setCampusId] = useState("");
  const [courseId, setCourseId] = useState("");
  const [classId, setClassId] = useState("");
  const [sectionId, setSectionId] = useState("");
  const [subjectId, setSubjectId] = useState("");
  const [testTypeId, setTestTypeId] = useState("");
  const [testDetails, setTestDetails] = useState([]);

  const pageStyle = `
  @page {
    margin-left: 1.5in;
    size: legal landscape !important;
}
`;
  const [printloading, setprintloading] = React.useState(false);
  const [text, setText] = React.useState("old boring text");
  const componentRef = useRef(null);
  const tableRef = useRef(null);
  const onBeforeGetContentResolve = React.useRef(null);

  const [loading, setloading] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const alert = useAlert();
  const [testTypeData, setTestTypeData] = useState([]);
  const [unitName, setUnitName] = useState("");
  const [icon, setIcon] = useState([]);

  useEffect(() => {
    getAllSessions();
    getSettingData();
    getTestType();
    getAllSubjects();
  }, []);

  const getAllSessions = () => {
    fetch(`${baseUrl}/session`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setAllSessions([...data.payload]);
        data.payload.forEach((session, index) => {
          if (session.active_academic_year == "1") {
            setCurrentSession(session.id);
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getSettingData = async () => {
    await fetch(`${baseUrl}/get-settings`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setUnitName(upperCase(data.payload.settings.unit_name));
        setIcon(data.payload.settings.logo_file);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getTestType = async () => {
    await fetch(`${baseUrl}/test-type`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setTestTypeData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
        setloading(false);
      });
  };

  const getAllSubjects = async () => {
    await fetch(`${baseUrl}/subject`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setAllSubjects(data.payload);
      })
      .catch((err) => {
        console.log("vehicle", err);
      });
  };

  const onCampusChange = (id) => {
    setCampusId(id);
    setCampusCourseData([]);
    setCourseClassData([]);
    setClassSectionData([]);
    setCourseId("");
    setClassId("");
    setSectionId("");
    getCampusCourses(id);
  };

  const getCampusCourses = async (campusId) => {
    if (campusId == "") {
      return alert.error("Please Select Campus");
    }
    await fetch(`${baseUrl}/campus-all-courses/${campusId}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setCourseId("");
          setClassId("");
          setCampusCourseData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const onCourseChange = (id) => {
    setCourseId(id);
    setCourseClassData([]);
    setClassSectionData([]);
    setClassId("");
    setSectionId("");
    getCourseClasses(id);
  };

  const getCourseClasses = async (courseId) => {
    if (courseId == "") {
      return alert.error("Please Select Course");
    }
    await fetch(`${baseUrl}/course-all-classes/${courseId}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setClassId("");
          setCourseClassData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const onClassChange = (id) => {
    setClassId(id);
    setClassSectionData([]);
    setSectionId("");
    getSectionsList(id);
  };

  const getSectionsList = (id) => {
    if (id == "" || campusId == "" || courseId == "") {
      alert.error("Please Select Campus / Course/ Class");
      return;
    }
    fetch(`${baseUrl}/class-section/${campusId}/${courseId}/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setClassSectionData(data.payload);
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // Main functions
  const getTestResult = () => {
    setTestDetails([]);
    setloading(true);
    setIsVisible(false);

    fetch(
      `${baseUrl}/test/${currentSession != "" ? currentSession : null}/${
        campusId != "" ? campusId : null
      }/${courseId != "" ? courseId : null}/${classId != "" ? classId : null}/${
        sectionId != "" ? sectionId : null
      }/${subjectId != "" ? subjectId : null}/${
        testTypeId != "" ? testTypeId : null
      }/${null}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${authtoken}`,
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata.success) {
          setTestDetails(data.payload);
          setloading(false);
          setIsVisible(true);
        } else if (!data.metadata.success) {
          alert.error(data.metadata.message);
          setloading(false);
          setIsVisible(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleBeforePrint = React.useCallback(() => {}, []);
  const handleOnBeforeGetContent = React.useCallback(() => {
    setprintloading(true);
    setText("Loading new text...");

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setprintloading(false);
        setText("New, Updated Text!");
        resolve();
      }, 2000);
    });
  }, [setprintloading, setText]);
  const handleAfterPrint = React.useCallback(() => {}, []);

  // Extract unique students from all test results
  const uniqueStudents = [
    ...new Map(
      testDetails.flatMap((test) =>
        test.test_results.map((result) => [
          result.student.admission_id,
          result.student,
        ])
      )
    ).values(),
  ];

  return (
    <div>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        <div className="row mt-5">
          <div className="col-md-3">
            <label>
              <b>Select Session</b>
              <span style={{ color: "red", fontSize: 12 }}>*</span>
            </label>
            <select
              onChange={(e) => setCurrentSession(e.target.value)}
              className="form-select h-40px"
              value={currentSession}
              aria-label="Default select example"
            >
              <option value="">Select Session</option>
              {allSessions.map((session, index) => (
                <option key={index} value={session.id}>
                  {session.year}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label>
              <b>Select Campus</b>
              <span style={{ color: "red", fontSize: 12 }}>*</span>
            </label>
            <select
              className="form-select h-40px"
              name="campus_id"
              value={campusId}
              onChange={(e) => onCampusChange(e.target.value)}
              aria-label="Default select example"
            >
              <option value="">Select Campus</option>
              {campuses.map((campus, index) => (
                <option key={index} value={campus.id}>
                  {campus.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label>
              <b>Select Course </b> <span style={{ color: "red" }}>*</span>
            </label>
            <select
              className="form-select h-40px"
              name="course_id"
              value={courseId}
              onChange={(e) => onCourseChange(e.target.value)}
              style={{ backgroundColor: "white", height: 40 }}
              aria-label="Default select example"
            >
              <option value="">Select Course</option>
              {campusCourseData.map((item, index) => (
                <option key={index} value={item.course?.id}>
                  {item.course?.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label>
              <b>Select Class</b>
              <span style={{ color: "red", fontSize: 12 }}>*</span>
            </label>
            <select
              className="form-select h-40px"
              name="class_id"
              value={classId}
              onChange={(e) => onClassChange(e.target.value)}
              aria-label="Default select example"
            >
              <option value="">Select Class</option>
              {courseClassData.map((item, index) => (
                <option key={index} value={item.class?.id}>
                  {item.class?.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="row mt-3 mb-5">
          <div className="col-md-3">
            <label>
              <b>Select Section</b>
              <span style={{ color: "red", fontSize: 12 }}>*</span>
            </label>

            <select
              className="form-select h-40px"
              name="section_id"
              value={sectionId}
              onChange={(e) => setSectionId(e.target.value)}
              aria-label="Default select example"
            >
              <option value="">Select Section</option>
              {classSectionData.map((item, index) => (
                <option key={index} value={item.section?.id}>
                  {item.section?.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label>
              <b>Select Test Type</b>
              <span style={{ color: "red", fontSize: 12 }}>*</span>
            </label>
            <select
              onChange={(e) => {
                setTestTypeId(e.target.value);
              }}
              className="form-select h-40px"
              value={testTypeId}
              aria-label="Default select example"
            >
              <option value="">Select Test Type</option>
              {testTypeData.map((test, index) => (
                <option key={index} value={test.id}>
                  {test?.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label>
              <b>Select Subject</b>
              <span style={{ color: "red", fontSize: 12 }}>*</span>
            </label>
            <select
              style={{ height: 40 }}
              className="form-select"
              name="class_id"
              value={subjectId}
              onChange={(e) => setSubjectId(e.target.value)}
              aria-label="Default select example"
            >
              <option value="">Select Subject</option>
              {allSubjects.map((sub, index) => (
                <option key={index} value={sub.id}>
                  {sub.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="d-flex mt-5">
          <button className="btn btn-primary w-205px" onClick={getTestResult}>
            Get All Test
          </button>
          {testDetails.length > 0 && (
            <>
              <ReactToPrint
                pageStyle={pageStyle}
                documentTitle={`Daily Test System Report`}
                onAfterPrint={handleAfterPrint}
                onBeforeGetContent={handleOnBeforeGetContent}
                onBeforePrint={handleBeforePrint}
                removeAfterPrint={true}
                trigger={() => (
                  <button
                    disabled={printloading ? true : false}
                    className="btn btn-primary w-100px mx-2"
                  >
                    {printloading ? <span>Printing..</span> : "Print"}
                  </button>
                )}
                content={() => componentRef.current}
              />
              <DownloadTableExcel
                filename="Daily Test System Report"
                sheet="Daily Test System Report"
                currentTableRef={tableRef.current}
              >
                <button className="btn btn-primary mx-2">Export</button>
              </DownloadTableExcel>
            </>
          )}
        </div>

        <div className="row justify-content-center">
          {loading && (
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          )}
        </div>

        {isVisible ? (
          <>
            <div className="mt-5">
              <div className="row p-3 mt-8">
                <img
                  style={{ height: 100, width: 110 }}
                  src={icon}
                  alt="Logo"
                />

                <div className="col-md-10">
                  <h1>{unitName}</h1>
                  <h5>
                    Daily Test Report of {testDetails[0]?.subject?.name}
                    {", "}
                    {testDetails[0]?.campus?.name}
                    {", "}
                    {testDetails[0]?.course?.name} (
                    {testDetails[0]?.student_class?.name}{" "}
                    {testDetails[0]?.global_section?.name}) Session{" "}
                    {testDetails[0]?.session?.year}
                  </h5>
                </div>
              </div>
              <Table
                style={{
                  width: "120%",
                  marginTop: "15px",
                  overflowY: "scroll",
                }}
                responsive
              >
                <thead>
                  <tr>
                    <th className="text-center">Sr.No</th>
                    <th className="text-center">Adm-ID</th>
                    <th className="text-center">Student Name</th>
                    <th className="text-center">Mobile No.</th>
                    {testDetails.map((testList, index) => (
                      <th className="text-center">{testList?.date}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="text-center">---</td>
                    <td className="text-center">---</td>
                    <td className="text-center">---</td>
                    <td className="text-center">---</td>
                    {testDetails.map((testList, index) => (
                      <td className="text-center">
                        <b>{testList?.full_marks}</b>
                      </td>
                    ))}
                  </tr>
                  {uniqueStudents.map((student, studentIndex) => (
                    <tr key={student.admission_id}>
                      <td className="text-center">{studentIndex + 1}</td>
                      <td className="text-center">{student.admission_id}</td>
                      <td className="text-center">{student.name}</td>
                      <td className="text-center">{student.mobile_no}</td>
                      {/* Loop through testDetails to fetch marks for this student */}
                      {testDetails.map((test, testIndex) => {
                        const result = test?.test_results?.find(
                          (r) =>
                            r?.student?.admission_id === student.admission_id
                        );
                        return (
                          <td key={testIndex} className="text-center">
                            {result?.gain_marks ?? "-"}
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </>
        ) : null}

        <div
          ref={componentRef}
          id="printSection"
          className="customTablePrint"
        >
          <div className="row p-3 mt-8">
            <img style={{ height: 100, width: 110 }} src={icon} alt="Logo" />

            <div className="col-md-10">
              <h1 className="text-black">{unitName}</h1>
              <h5 className="text-black">
                Daily Test Report of {testDetails[0]?.subject?.name}
                {", "}
                {testDetails[0]?.campus?.name}
                {", "}
                {testDetails[0]?.course?.name} (
                {testDetails[0]?.student_class?.name}{" "}
                {testDetails[0]?.global_section?.name}) Session{" "}
                {testDetails[0]?.session?.year}
              </h5>
            </div>
          </div>
          <table style={{ width: "100%" }}>
            <thead>
              <tr>
                <th
                  className="text-center text-black"
                  style={{ border: "1px solid black", fontSize: "16px" }}
                >
                  Sr.No
                </th>
                <th
                  className="text-center text-black"
                  style={{ border: "1px solid black", fontSize: "16px" }}
                >
                  Adm-ID
                </th>
                <th
                  className="text-center text-black"
                  style={{ border: "1px solid black", fontSize: "16px" }}
                >
                  Student Name
                </th>
                <th
                  className="text-center text-black"
                  style={{ border: "1px solid black", fontSize: "16px" }}
                >
                  Mobile No.
                </th>
                {testDetails.map((testList, index) => (
                  <th
                    className="text-center text-black hereLineheighter rotateIT"
                    style={{ border: "1px solid black", fontSize: "16px" }}
                  >
                    <p>{testList?.date}</p>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  className="text-center text-black"
                  style={{ border: "1px solid black", fontSize: "14px" }}
                >
                  ---
                </td>
                <td
                  className="text-center text-black"
                  style={{ border: "1px solid black", fontSize: "14px" }}
                >
                  ---
                </td>
                <td
                  className="text-center text-black"
                  style={{ border: "1px solid black", fontSize: "14px" }}
                >
                  ---
                </td>
                <td
                  className="text-center text-black"
                  style={{ border: "1px solid black", fontSize: "14px" }}
                >
                  ---
                </td>
                {testDetails.map((testList, index) => (
                  <td
                    className="text-center text-black"
                    style={{ border: "1px solid black", fontSize: "14px" }}
                  >
                    <b>{testList?.full_marks}</b>
                  </td>
                ))}
              </tr>
              {uniqueStudents.map((student, studentIndex) => (
                <tr key={student.admission_id}>
                  <td
                    className="text-center text-black"
                    style={{ border: "1px solid black", fontSize: "14px" }}
                  >
                    {studentIndex + 1}
                  </td>
                  <td
                    className="text-center text-black"
                    style={{ border: "1px solid black", fontSize: "14px" }}
                  >
                    {student.admission_id}
                  </td>
                  <td
                    className="text-center text-black"
                    style={{ border: "1px solid black", fontSize: "14px" }}
                  >
                    {student.name}
                  </td>
                  <td
                    className="text-center text-black"
                    style={{ border: "1px solid black", fontSize: "14px" }}
                  >
                    {student.mobile_no}
                  </td>
                  {/* Loop through testDetails to fetch marks for this student */}
                  {testDetails.map((test, testIndex) => {
                    const result = test?.test_results?.find(
                      (r) => r?.student?.admission_id === student.admission_id
                    );
                    return (
                      <td
                        key={testIndex}
                        className="text-center text-black"
                        style={{ border: "1px solid black", fontSize: "14px" }}
                      >
                        {result?.gain_marks ?? "-"}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <Table ref={tableRef} style={{ display: "none" }}>
          <thead>
            <tr>
              <th className="text-center">Sr.No</th>
              <th className="text-center">Adm-ID</th>
              <th className="text-center">Student Name</th>
              <th className="text-center">Mobile No.</th>
              {testDetails.map((testList, index) => (
                <th className="text-center">{testList?.date}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="text-center">---</td>
              <td className="text-center">---</td>
              <td className="text-center">---</td>
              <td className="text-center">---</td>
              {testDetails.map((testList, index) => (
                <td className="text-center">
                  <b>{testList?.full_marks}</b>
                </td>
              ))}
            </tr>
            {uniqueStudents.map((student, studentIndex) => (
              <tr key={student.admission_id}>
                <td className="text-center">{studentIndex + 1}</td>
                <td className="text-center">{student.admission_id}</td>
                <td className="text-center">{student.name}</td>
                <td className="text-center">{student.mobile_no}</td>
                {/* Loop through testDetails to fetch marks for this student */}
                {testDetails.map((test, testIndex) => {
                  const result = test?.test_results?.find(
                    (r) => r?.student?.admission_id === student.admission_id
                  );
                  return (
                    <td key={testIndex} className="text-center">
                      {result?.gain_marks ?? "-"}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </Table>
      </Paper>
    </div>
  );
};

export default DailyTestReport;
